const CHUNK_LOAD_ERROR_MESSAGES = [
  'Failed to fetch dynamically imported module', // Chromium
  'error loading dynamically imported module', // Firefox
  'Importing a module script failed', // Safari
];

const RELOAD_COUNT_KEY = 'chunk-error-reload-count';
const RELOAD_TS_KEY = 'chunk-error-reload-ts';

const MAX_RELOADS_PER_INCIDENT = 1;

// Must outlast one reactLazyWithRetry cycle (~15.5s backoff + fetches) plus a
// reboot, so a post-reload recurrence still counts against the same incident
// rather than looking like a fresh one.
const NEW_INCIDENT_AFTER_MS = 120_000;

export const CHUNK_AUTO_RECOVER_TAG = 'chunk_auto_recover';

export const isChunkLoadError = (error: unknown): boolean => {
  const message = error instanceof Error ? error.message : String(error);
  return CHUNK_LOAD_ERROR_MESSAGES.some((knownMessage) => message.includes(knownMessage));
};

const reloadsUsedThisIncident = (): number => {
  const lastReloadAt = Number(sessionStorage.getItem(RELOAD_TS_KEY) ?? 0);
  const isStaleIncident = Date.now() - lastReloadAt > NEW_INCIDENT_AFTER_MS;
  return isStaleIncident ? 0 : Number(sessionStorage.getItem(RELOAD_COUNT_KEY) ?? 0);
};

export const isChunkReloadInProgress = (): boolean => reloadsUsedThisIncident() > 0;

export const reloadOnChunkError = (error: unknown): boolean => {
  if (!isChunkLoadError(error) || reloadsUsedThisIncident() >= MAX_RELOADS_PER_INCIDENT) {
    return false;
  }

  sessionStorage.setItem(RELOAD_COUNT_KEY, String(reloadsUsedThisIncident() + 1));
  sessionStorage.setItem(RELOAD_TS_KEY, String(Date.now()));
  window.location.reload();
  return true;
};
